<template>
    <div class="apprentice-simple-card remove-bottom-card-margin">
        <design-2021-apprentice-data-table
            v-if="users.length"
            nosearch
            :items="users"
            :fields="projectUsersFields">
            <template v-slot:options>
                <b-button
                    class="btn-add btn-add-user"
                    v-b-modal="'add-user-modal'"
                    v-if="!AuthIsStudent"
                    variant="primary">
                    {{ $t('project.add_participant') }}
                </b-button>
            </template>
            <template v-slot:cell(action)="data">
                <b-button
                    class="btn-remove btn-remove-user remove-icon-margin"
                    v-if="!AuthIsStudent"
                    variant="danger-icon-only"
                    @click="removeUser(data.item.id)">
                </b-button>
            </template>
            <template v-slot:cell(type)="data">
                <div class="type">
                    {{ getLocalisedType(data.item.type) }}
                </div>
            </template>
        </design-2021-apprentice-data-table>

        <div
            class="not-found with-header"
            v-else>
            <div class="header">
                <b-button
                    class="btn-add btn-add-user"
                    v-b-modal="'add-user-modal'"
                    v-if="!AuthIsStudent"
                    variant="primary">
                    {{ $t('project.add_participant') }}
                </b-button>
            </div>

            <div class="icon">
                <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="alert-notice">{{ $t('project.no_participants_found') }}</div>
        </div>

        <design-2021-project-show-add-user-modal-component
            v-if="!AuthIsStudent"
            :project-id="projectIn.id"
            @user-added="addUser($event)"
            ref="project-show-add-user-modal-component">
        </design-2021-project-show-add-user-modal-component>
    </div>
</template>

<script>
export default {
    name: 'project-show-participator-component',
    props: ['projectIn'],
    data() {
        return {
            users: this.projectIn.users,
            projectUsersFields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'email',
                    label: this.$t('common.email_address'),
                },
                {
                    key: 'type',
                    label: this.$t('project.role'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
            AuthIsStudent: this.$authUser.isStudent(),
        };
    },
    methods: {
        addUser(id) {
            this.alert.saving();

            const data = {
                project_id: this.projectIn.id,
                user_id: id,
            };

            this.axios.post(this.routes.projectAddUser(), data).then(
                (response) => {
                    this.users.push(response.data.user);
                    this.$refs['project-show-add-user-modal-component'].reload();
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        removeUser(id) {
            this.alert
                .confirm(
                    this.$t('project.delete_participant'),
                    this.$t('project.are_you_sure_you_want_to_delete_this_participant'),
                )
                .then((confirm) => {
                    if (confirm) {
                        this.alert.saving();

                        const data = {
                            project_id: this.projectIn.id,
                            user_id: id,
                        };

                        this.axios.post(this.routes.projectRemoveUser(), data).then(
                            (response) => {
                                this.users = this.users.filter((item) => item.id !== id);
                                this.alert.success();
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                    }
                });
        },
        getLocalisedType(type) {
            switch (type) {
                case 'student':
                    return this.$t('project.student');
                case 'teacher':
                    return this.$t('project.teacher');
            }
        },
    },
};
</script>

<style scoped lang="scss">
.no-users-found {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .btn-add-user {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }
}
</style>
